/* eslint-disable */


/**
 * Create styles for `<Modal />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Modal />` styles
 */
const modalStyles = ({ theme }) => ({
  dialogContent: {
    minWidth: 300,
  },
  dialogFooter: {
    padding: `${theme.spacing(1) * 2}px  ${theme.spacing(1) * 3}px ${theme.spacing(1) * 2}px ${theme.spacing(1) * 3}px`,
  },
  dialogTitleRoot: {
    padding: theme.spacing(1) * 1.1,
    paddingLeft: theme.spacing(1) * 1.4,
    paddingRight: theme.spacing(1) * 2,
  },
  iconButton: {
    marginRight: theme.spacing(1),
  },
  paperScrollPaper: {
    minHeight: `calc(100% - 96px)`,
  },
  icon: {
    margin: `${theme.spacing(1)}px ${theme.spacing(1)}px 0px ${theme.spacing(1) * 2}px`,
  },
});

export default modalStyles;
